
import FinAgentSnippetPreview from '@/components/finagent/FinAgentSnippetPreview';
import FinAgentThinkingMessage from '@/components/finagent/FinAgentThinkingMessage';
import CopyActionsContainer from '@/components/shared/CopyActionsContainer';
import FormatterService from '@/service/FormatterService';
import { finAgentMenuHandler } from '@/mixins';

export default {
    name: 'FinAgentMessage',

    components: {
        CopyActionsContainer,
        FinAgentSnippetPreview,
        FinAgentThinkingMessage,
    },

    mixins: [finAgentMenuHandler],

    props: {
        isUserMessage: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            default: '',
        },
        isAgentThinking: {
            type: Boolean,
            default: false,
        },
        isLoadingContent: {
            type: Boolean,
            default: false,
        },
        widgets: {
            type: Array,
            default: () => [],
        },
        isAtBottom: {
            type: Boolean,
            default: true,
        },
        created: {
            type: String,
            default: ''
        },
        isStreaming: {
            type: Boolean,
            default: false,
        },
        messageId: {
            type: [Number, String],
            default: null,
        },
        recurringId: {
            type: [Number, String],
            default: null,
        },
        finagentLibraries: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['update-widgets-data', 'update-menu-state', 'click-save-snippet', 'click-create-auto-ask-question', 'click-update-auto-ask-question'],

    computed: {
        hasDetailsInformationWidgets() {
            return this.widgets && this.widgets.length > 0
        },
        detailsIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/finagent-details-icon-dark.svg') :
                require('@/assets/icons/finagent-details-icon-light.svg');
        },
        saveSnippetIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-save-snippet-dark.svg') :
                require('@/assets/icons/fin-agent-save-snippet-light.svg');
        },
        finAgentAvatar() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-answer-avatar-dark.svg') :
                require('@/assets/icons/fin-agent-answer-avatar-light.svg');
        },
        finAgentAutoAskIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-chat-auto-ask-dark.svg') :
                require('@/assets/icons/fin-agent-chat-auto-ask-light.svg');
        },
        finAgentEditAutoAskIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-edit-auto-ask-dark.svg') :
                require('@/assets/icons/fin-agent-edit-auto-ask-light.svg');
        },
        showDetailsInformationButton() {
            return !this.isUserMessage && this.hasDetailsInformationWidgets && this.$isFinAgentPage(this.$route);
        },
        snippetId() {
            return this.finagentLibraries.length > 0 ? this.finagentLibraries[0].id : null;
        },
        snippetContent() {
            return this.finagentLibraries.length > 0 ? this.finagentLibraries[0].message : null;
        },
        snippetTitle() {
            return this.finagentLibraries.length > 0 ? this.finagentLibraries[0].title : null;
        },
        isSavedAsSnippet() {
            return !this.isUserMessage && this.snippetContent && this.snippetId && this.$isFinAgentPage(this.$route);
        },
        showSaveSnippetButton() {
            return !this.isUserMessage && !this.isStreaming && !this.isSavedAsSnippet && this.$isFinAgentPage(this.$route);
        },
        isLoading() {
            return this.isAgentThinking || this.isLoadingContent;
        },
        isSavedAsAutoAskQuestion() {
            return this.isUserMessage && this.$isFinAgentPage(this.$route) && this.recurringId;
        },
        showUserButtonsRow() {
            return this.isUserMessage && !this.isLoading && this.$isFinAgentPage(this.$route);
        },
    },

    created() {
        this.format = new FormatterService();
    },

    methods: {
        handleClickSeeDetails() {
            this.$emit('update-widgets-data', this.widgets);
        },
        handleClickMessageContent(event) {
            const finAgentData = this.handleClickFinAgentContent(event);

            if (finAgentData) {
                this.$emit('update-menu-state', finAgentData);
            }
        },
        getFirstLineText(messageContent) {  
            if (!messageContent) {  
                return '';  
            }

            // Split by line breaks and get the first non-empty line  
            const lines = messageContent.split(/\r?\n/);
                
            for (const line of lines) {  
                const trimmedLine = line.trim();  
                if (trimmedLine) {  
                    return trimmedLine
                        .replace(/^#+\s+/, '') // Remove heading markers
                        .replace(/\*\*(.*?)\*\*/g, '$1') // Remove bold
                        .replace(/\*(.*?)\*/g, '$1') // Remove italic
                        .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Remove links but keep text
                        .replace(/`(.*?)`/g, '$1'); // Remove code blocks
                }  
            }

            return '';
        },
        handleClickSaveSnippet() {
            const payload = { messageId: this.messageId, title: this.getFirstLineText(this.content) };
            this.$emit('click-save-snippet', payload);
        },

        handleClickCreateAutoAskQuestion() {
            const payload = {
                messageId: this.messageId,
                messageContent: this.content
            };
            this.$emit('click-create-auto-ask-question', payload);
        },

        handleClickUpdateAutoAskQuestion() {
            const payload = {
                messageId: this.messageId,
                messageContent: this.content,
                recurringId: this.recurringId,
            };
            this.$emit('click-update-auto-ask-question', payload);
        },
    }
}
